import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="border-y border-celeste/15 bg-abyss/40 py-16 sm:py-20" aria-labelledby="guarantee-title" data-id="element-73" data-mp="4vs0rz0u8fre">
      <div className="mx-auto max-w-2xl px-4 text-center" data-id="element-74" data-mp="9t1n35sxkbb0">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="rounded-3xl border-2 border-celeste/40 bg-ink/60 p-8 shadow-2xl shadow-black/40 backdrop-blur-md sm:p-12" data-id="element-75" data-mp="etpl4bfktseq">
          <span className="inline-flex rounded-full border border-celeste/50 bg-abyss/60 p-4 text-celeste" data-id="element-76" data-mp="xjxjkg8bzuol">
            <ShieldCheckIcon className="h-10 w-10 drop-shadow-[0_0_6px_rgba(94,200,242,0.55)]" aria-hidden="true" data-id="element-77" data-mp="12ja58xnguvpl" />
          </span>
          <h2 id="guarantee-title" className="mt-6 text-balance text-3xl font-extrabold uppercase tracking-tight text-white sm:text-4xl" data-id="element-78" data-mp="17iwlzh2i6u35">
            Garanzia di soddisfazione <span className="text-gold" data-id="element-79" data-mp="20t3tmpavisw6">di 7 giorni</span>
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-mist" data-id="element-80" data-mp="20v6uy5hh88g7">
            Se entro 7 giorni il materiale non fa per te,{' '}
            <span className="font-extrabold text-gold" data-id="element-81" data-mp="1rsntnptca3w2">ti rimborsiamo. Senza domande.</span>
          </p>
        </motion.div>
      </div>
    </section>;
}